module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dia_container"
  }, [_c('div', {
    staticClass: "form_line cl"
  }, [_c('label', {
    staticClass: "l"
  }, [_vm._v("资源名称：")]), _vm._v(" "), _c('div', {
    staticClass: "l inpt"
  }, [_c('el-input', {
    model: {
      value: (_vm.resource.resourcename),
      callback: function($$v) {
        _vm.$set(_vm.resource, "resourcename", $$v)
      },
      expression: "resource.resourcename"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form_line cl"
  }, [_c('label', {
    staticClass: "l"
  }, [_vm._v("配置值：")]), _vm._v(" "), _c('div', {
    staticClass: "l inpt"
  }, [_c('el-input', {
    model: {
      value: (_vm.resource.conf),
      callback: function($$v) {
        _vm.$set(_vm.resource, "conf", $$v)
      },
      expression: "resource.conf"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dia_btn_container"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1f7e5136", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f7e5136","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/packageConfig/configEdit.vue
// module id = 254
// module chunks = 0